export default {"src":"/_next/static/media/brand-emf.3c14cc3b.svg","height":83,"width":92};